import { Input } from "../../../../components/ui/input";
import { Plus } from "lucide-react";

/**
 * RecipientsPanel — Phase 8 saved recipient address book. Frequently
 * used B2B ship-tos with search + Add recipient CTA.
 * Extracted from SellerDropship.jsx in Phase 4 refactor.
 */
export default function RecipientsPanel({
  recipients, recipientQ, setRecipientQ,
  loadRecipients, setRecipientDraft, deleteRecipient,
}) {
  return (
  <div className="rounded-2xl border border-border bg-white overflow-hidden" data-testid="fulfillment-recipients-panel">
    <div className="px-5 py-3 border-b border-border bg-secondary/40 flex items-center justify-between gap-3 flex-wrap">
      <div>
        <div className="text-[13px] font-medium">Recipient address book</div>
        <div className="text-[11px] text-foreground/55 mt-0.5">
          Save frequent B2B ship-to addresses. Auto-fills the manual-label form.
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Input placeholder="Search name / company / city / zip"
          value={recipientQ} onChange={e => setRecipientQ(e.target.value)}
          onBlur={() => loadRecipients(recipientQ)}
          data-testid="recipient-search" className="h-9 w-64 text-[12.5px]"/>
        <button onClick={() => setRecipientDraft({ name:"", company:"", street1:"", city:"", state:"", zip:"", country:"US", phone:"", email:"", tag:"" })}
          data-testid="recipient-add"
          className="inline-flex items-center gap-1 h-9 px-3 rounded-full text-[11px] mono uppercase tracking-[0.14em] border border-border bg-white hover:bg-secondary">
          <Plus className="w-3 h-3"/> Add recipient
        </button>
      </div>
    </div>
    {recipients.length === 0 ? (
      <div className="p-10 text-center text-[12px] text-foreground/55">No saved recipients yet.</div>
    ) : (
      <div className="divide-y divide-border">
        {recipients.map(r => (
          <div key={r.id} className="px-5 py-3 flex items-center justify-between gap-3" data-testid={`recipient-${r.id}`}>
            <div className="text-[12.5px]">
              <div className="font-medium">{r.name}{r.company ? ` · ${r.company}` : ""}</div>
              <div className="text-foreground/60 mono text-[11px]">
                {r.street1}{r.street2 ? `, ${r.street2}` : ""}, {r.city}, {r.state} {r.zip} · {r.country}
              </div>
              {(r.phone || r.email || r.tag) && (
                <div className="text-foreground/50 text-[11px] mt-0.5">
                  {[r.phone, r.email, r.tag && `#${r.tag}`].filter(Boolean).join(" · ")}
                </div>
              )}
            </div>
            <button onClick={() => deleteRecipient(r.id)}
              data-testid={`recipient-del-${r.id}`}
              className="text-[11px] mono uppercase tracking-[0.14em] text-rose-600 hover:text-rose-800">Remove</button>
          </div>
        ))}
      </div>
    )}
  </div>
  );
}
